import getMetaTagContent from '../../../../helpers/getMetaTagContent';
import {
    CREATION_TIME,
    CTX_ID,
    FACILITY,
    KNOWN_CRAWLER,
    PAGENAME,
    USER_ID,
    U_GUID
} from '../../../../helpers/metaTagIdentifiers';

let context;

/**
 * Generates a copy of a given record with enriched fields.
 */
export default function payload(record) {
    context = context || {
        page: {
            creation: getMetaTagContent(CREATION_TIME),
            ctx: getMetaTagContent(CTX_ID),
            name: getMetaTagContent(PAGENAME) || getMetaTagContent(FACILITY) || 'web',
            url: window.location.href,
            referrer: document.referrer || undefined
        },
        user: {
            id: getMetaTagContent(USER_ID),
            uid: getMetaTagContent(U_GUID),
            crawler: getMetaTagContent(KNOWN_CRAWLER) === 'true'
        }
    };
    return {
        context,
        log: [
            record
        ]
    };
}
